/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Input, InputSelect, Label, Modal, CustomLoading, SaveIcon } from "../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../Services/partscommandService";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { changeModal } from "../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, 
    ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../util/validate";

const ListPartsComands = () => {
    const { t } = useTranslation();

    document.title = t("administrative.partCommands.name");
    const Services = useRef(new PartsComandServices());
    const [partCommands, setPartCommands] = useState([]);
    const [defaultCategories, setDefaultCategories] = useState([]);
    const [variables, setVariables] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const NameField = useRef();
    const CommandField = useRef();
    const default_categoryField = useRef();
    const switch_variableField = useRef();

    const Namevalue = useRef();
    const Commandvalue = useRef();
    const default_categoryvalue = useRef();
    const switch_variablevalue = useRef();

    useEffect(() => {
        async function getAllPartCommands(){
            let currentList = await Services.current.getAllPartCommands();
            setPartCommands(currentList)
            setIsLoading(false)
        }

        async function getDefaultCategories(){
            let currentList = await Services.current.getDefaultCategories();
            setDefaultCategories(currentList)
        }

        async function getPartCommandsVariables(){
            let currentList = await Services.current.getPartCommandsVariables();
            currentList = currentList.filter(item => item.isSwitch === true)
            setVariables(currentList)
        }

        getPartCommandsVariables();
        getAllPartCommands();
        getDefaultCategories();
    },[])

    // Salva as edições do usuário
    async function Save(){
        store.dispatch(changeModal(''))
        if(isValidField(Namevalue.current)){
            let form = new FormData();
            if(Namevalue.current){form.append('title', Namevalue.current)}
            if(Commandvalue.current){form.append('Command', Commandvalue.current)}
            if(default_categoryvalue.current){form.append('default_category', default_categoryvalue.current)}
            if(switch_variablevalue.current){form.append('switch_variable', switch_variablevalue.current)}
    
            await Services.current.SaveCargo(form)
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <>
            <Container>
                <PageTitle>
                    {t("administrative.partCommands.title")}
                </PageTitle>

                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + partCommands.length + " " + t("administrative.partCommands.name") }
                    </CountContainer>

                    <Button onClick={()=>store.dispatch(changeModal('newPartCommand'))} width={'fit-content'} color={'green'} icon={''} text={"+ "+t("administrative.partCommands.add")}></Button>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>{t("header-table.name") }</TitleText>
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        partCommands?.map((item, index)=>(
                            <LineList key={index} href={`/PartCommands/${item.id}`}>
                                <ListText>{item.name}</ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>
            </Container>
            
            <Modal title={t("administrative.partCommands.add")} name={'newPartCommand'} width={'70%'} height={'90%'} >
                
                <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                    <ContainerColumn>
                        <Label text={t("inputs.name.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='name' 
                            name='name' 
                            type="text" 
                            placeholder= {t("inputs.name.placeholder")}
                            innerRef={NameField}
                            invalidMessage = {t("inputs.name.invalid-message")}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => Namevalue.current = text}> 
                        </Input>

                        <Label text={"Comando"} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='Command' 
                            name='Command' 
                            type="text" 
                            placeholder= {"Comando"}
                            innerRef={CommandField}
                            invalidMessage = {"Comando inválido!"}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => Commandvalue.current = text}> 
                        </Input>
                        
                    </ContainerColumn>
                    
                    <ContainerColumn>
                        <Label text={"Categoria padrão"} aling="flex-start"/>
                        <InputSelect
                            key={'default_category'}
                            name={'default_category'}
                            id={'default_category'}
                            placeholder={"Categoria padrão"}
                            invalidMessage = {"Categoria padrão inválida!"}
                            options={defaultCategories}
                            innerRef={default_categoryField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => default_categoryvalue.current = value}>
                        </InputSelect>
                        
                        <Label text={"Variável de estado"} aling="flex-start"/>
                        <InputSelect 
                            key={'switch_variable'}
                            id='switch_variable' 
                            name='switch_variable' 
                            placeholder= {"Variável de estado"}
                            options={variables}
                            innerRef={switch_variableField}
                            invalidMessage = {"Variável de estado inválida!"}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => switch_variablevalue.current = text}> 
                        </InputSelect>
                    </ContainerColumn>
                </ContainerRow>

                
                <ButtonsContainer>
                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                    <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={()=>store.dispatch(changeModal(''))}/>
                </ButtonsContainer>
            </Modal>
        </>
    )
}

export default ListPartsComands;